module.exports = __webpack_public_path__ + "static/media/bcom-actuarial-studies_LR.87bf09fe.jpg";